// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__FU5FZ","greetings":"Contact_greetings__ML+88","contact_instructions":"Contact_contact_instructions__7IGAj","email":"Contact_email__PQKPs"};